import { handleAvailable, handleRequest, handleUnavailable } from '../reducerHandlers';
import { createReducer } from './utils';

import {
    INSIGHTS_FAILURE,
    INSIGHTS_LOADING,
    INSIGHTS_SUCCESS,
    SNACK_SET,
} from './constants';

const defaultState = {
    dashboards: [],
    currentDashboard: null,
    currentChart: null,
    loading: false,
    error: null,
};

export const reducer = createReducer(defaultState, {
    [INSIGHTS_LOADING]: handleRequest,
    [INSIGHTS_SUCCESS]: handleAvailable,
    [INSIGHTS_FAILURE]: handleUnavailable,
});

export function fetchUserDashboards() {
    return async (dispatch, _, { services: { dataSource } }) => {
        const keyState = 'dashboards';
        const loadingName = 'loading';
        dispatch({ type: INSIGHTS_LOADING, payload: { loadingName } });
        try {
            const response = await dataSource.getInsightsDashboards();
            dispatch({
                type: INSIGHTS_SUCCESS,
                payload: { keyState, data: response, loadingName },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: INSIGHTS_FAILURE,
                payload: { keyState, loadingName, defaultState: [] },
            });
            const snack = {
                open: true,
                message: 'There was an error loading dashboards.',
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}

export function fetchDashboardDetail(dashboardId) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const keyState = 'currentDashboard';
        const loadingName = 'loading';
        dispatch({ type: INSIGHTS_LOADING, payload: { loadingName } });
        try {
            const response = await dataSource.getInsightsDashboardDetail(dashboardId);
            dispatch({
                type: INSIGHTS_SUCCESS,
                payload: { keyState, data: response, loadingName },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: INSIGHTS_FAILURE,
                payload: { keyState, loadingName, defaultState: null },
            });
            const snack = {
                open: true,
                message: 'There was an error loading dashboard detail.',
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}

export function fetchChartData(chartId) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const keyState = 'currentChart';
        const loadingName = 'loading';
        dispatch({ type: INSIGHTS_LOADING, payload: { loadingName } });
        try {
            const response = await dataSource.getInsightsChart(chartId);
            dispatch({
                type: INSIGHTS_SUCCESS,
                payload: { keyState, data: response, loadingName },
            });
            // Return the response so callers can use Promise.all for parallel chart loading
            return response;
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: INSIGHTS_FAILURE,
                payload: { keyState, loadingName, defaultState: null },
            });
            const snack = {
                open: true,
                message: 'There was an error loading chart data.',
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
            return null;
        }
    };
}
